"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
require("../../scss/_forms.scss");
/**
 * @component TextField
 * @example
 * return(
 *   <TextField
 *     label="Middle Initials"
 *     maxLength={2}
 *     name="middleName"
 *     value={formik.values.middleName}
 *     onChange={formik.handleChange}
 *     onBlur={formik.handleBlur}
 *     required={false}
 *   />
 * )
 *
 *
 * @param {string} name name of the field;
 * @param {string | number | null} value value of the field
 * @param {boolean} disabled is the field disabled
 * @param {function} onChange what happens on change of the field
 * @param {function} onBlur what happens when the user focuses away from the field
 * @param {function} onClick what happens when the user clicks the field
 * @param {string | boolean} error error message
 * @param {string} type the type of text field - one of "text" | "number" | "password" | "email" | "date"
 * @param {boolean} required is this field required;
 * @param {string} label descriptive label to display on the field;
 * @param {number} minLength minimum length of the text to be entered in the field;
 * @param {number} maxLength maximum length of the text to be entered in the field
 * @param {string} multiline is this field a textArea?
 * @param {number} min min to be passed to inputProps
 * @param {number} max max to be passed to inputProps
 * @param {string} pattern pass in a regEx to be passed to inputProps
 * @param {boolean} select  boolean for whether or not this is a 'Select' dropdown instead of standard input
 * @param {boolean} loading is the field loading? (if it is a select and there is no data yet)
 * @param {number} loadingLeftPosition shift the loading bar horizontally
 * @param {string} placeholder placeholder string
 * @param {string} variant one of: "filled" | "outlined" | "standard"
 * @param {Component} startAdornment pass a MUI icon here to display at the beginning of the text field
 * @param {Component} endAdornment pass a MUI icon here to display at the end of the text field
 * @param {string} helperText hint text
 * @param {string} className pass in styles here
 * @param {string} children children of the text field
 * @param {number} rows
 * @param {boolean} autoComplete will the field autocomplete? (like a search)
 *
 */
var TextField = function (props) {
    var name = props.name, _a = props.value, value = _a === void 0 ? null : _a, disabled = props.disabled, onChange = props.onChange, onBlur = props.onBlur, onClick = props.onClick, error = props.error, defaultValue = props.defaultValue, _b = props.type, type = _b === void 0 ? "text" : _b, _c = props.required, required = _c === void 0 ? true : _c, label = props.label, minLength = props.minLength, maxLength = props.maxLength, multiline = props.multiline, _d = props.min, min = _d === void 0 ? 5 : _d, _e = props.max, max = _e === void 0 ? 10 : _e, pattern = props.pattern, _f = props.select, select = _f === void 0 ? false : _f, _g = props.loading, loading = _g === void 0 ? false : _g, _h = props.loadingLeftPosition, loadingLeftPosition = _h === void 0 ? 0 : _h, placeholder = props.placeholder, _j = props.variant, variant = _j === void 0 ? "outlined" : _j, _k = props.startAdornment, startAdornment = _k === void 0 ? "" : _k, _l = props.endAdornment, endAdornment = _l === void 0 ? "" : _l, helperText = props.helperText, className = props.className, children = props.children, rows = props.rows, autoComplete = props.autoComplete, _m = props["test-id"], testId = _m === void 0 ? "" : _m;
    function getHelperText() {
        if (error) {
            return;
        }
        if (!required) {
            return helperText ? "(Optional) ".concat(helperText) : "Optional";
        }
        return helperText;
    }
    var textField = (react_1.default.createElement("div", { className: "MuiTextField-root" },
        react_1.default.createElement(material_1.TextField, { className: "text-field\n          ".concat(className, "\n          ").concat(value && value < 0 ? "placeholder" : ""), disabled: disabled || loading, fullWidth: true, name: name, value: value, select: select, error: !!error, defaultValue: defaultValue, multiline: multiline, onChange: onChange, onBlur: onBlur, onClick: onClick, placeholder: placeholder, variant: variant, required: required, helperText: getHelperText(), label: label, rows: rows, autoComplete: autoComplete ? "on" : "off", inputProps: { maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, type: type, value: value, 'test-id': testId }, InputProps: (startAdornment || endAdornment) && {
                startAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: "start" }, startAdornment)),
                endAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: "end" }, endAdornment)),
            } }, children),
        error && (react_1.default.createElement(material_1.Grid, { container: true, className: "error-message" },
            react_1.default.createElement(material_1.Grid, { item: true },
                react_1.default.createElement(Warning_1.default, null)),
            react_1.default.createElement(material_1.Grid, { item: true }, error)))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "button" },
            textField,
            loading && (react_1.default.createElement(material_1.LinearProgress, { className: "progress", style: { left: loadingLeftPosition + 'rem', top: -11 } })))));
};
exports.default = TextField;
